import { render, staticRenderFns } from "./Periodo.vue?vue&type=template&id=329cf48f"
import script from "./Periodo.vue?vue&type=script&lang=js"
export * from "./Periodo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports